import React from 'react';
import ImageTextBlock from './ImageTextBlock';

const About: React.FC = () => (
  <section>
    <h2>About Me</h2>
    <ImageTextBlock
      imageSrc="/images/colin_piano_crop2.jpg"
      imageAlt="Collage of instruments for sale"
      text={
        <>
          I’ve always loved working with my hands, and I feel privileged to be able to combine craft with my passion for classical music. I trained as a classical cellist before attending violin making school. This experience allows me to better understand what is right for the player and the instrument.
          <br /><br />
          I take special pride in running a one man operation, I employ no apprentices or outsource work to contractors. When working with me, you can be guaranteed a high degree of personal attention.
        </>
      }
    />

    <h3>Prior Luthier Experience</h3>
    <ul>
      <li>Repairman/restorer, <a href="https://www.carriagehouseviolins.com/" target="_blank" rel="noopener noreferrer">Carriage House Violins</a> of <a href="https://www.johnsonstring.com/" target="_blank" rel="noopener noreferrer">Johnson String Instrument</a>, Newton, MA.</li>
      <li>Repairman/restorer, <a href="https://www.carriagehouseviolins.com/" target="_blank" rel="noopener noreferrer">Carriage House Violins</a> of <a href="https://www.reuning.com/" target="_blank" rel="noopener noreferrer">Reuning* &amp; Son Violins</a>, Newton, MA.</li>
      <li>Repairman/restorer, <a href="https://www.johnsonstring.com/" target="_blank" rel="noopener noreferrer">Johnson String Instrument</a>, Newton, MA.</li>
      <li>Apprentice to Paul Wiessmeyer*, <a href="https://www.bostonfiddle.com/" target="_blank" rel="noopener noreferrer">Wiessmeyer Violins</a>, Boston, MA.</li>
      <li>Apprentice to William Monical*, William Monical &amp; Son, New York, NY.</li>
      <li>Graduate, Violin Making &amp; Repair. <a href="https://nbss.edu/full-time-programs/violin-making-repair/" target="_blank" rel="noopener noreferrer">North Bennet Street School</a>, Boston, MA. Roman Barnas*, instructor.</li>
      <li>Attendee, Oberlin Restoration Workshop, Oberlin, OH.</li>
      <li>Attendee, Hans Nebel* Violin Repair Workshop, North Adams, MA.</li>
      <li>*Member and/or Founder of American Federation of Violin and Bow Makers.</li>
    </ul>

    <h3>Musician</h3>
    <ul>
      <li>Training in modern &amp; baroque cello, viola da gamba, chamber music, orchestra, <a href="http://new.oberlin.edu/" target="_blank" rel="noopener noreferrer">Oberlin College</a>, Oberlin, OH. Cathy Meints, Jay Humeston, Gregory Fulkerson, instructors.</li>
      <li>Cello &amp; chamber music studies, <a href="https://conservatoire-rennes.fr/" target="_blank" rel="noopener noreferrer">Conservatoire Régional de Rennes</a>, Rennes, France.</li>
      <li>Attendee, <a href="http://new.oberlin.edu/conservatory/summer/baroque-performance-institute/" target="_blank" rel="noopener noreferrer">Oberlin Baroque Performance Institute</a>, Oberlin, OH.</li>
      <li>Attendee, <a href="http://www.domaineforget.com/" target="_blank" rel="noopener noreferrer">Domaine Forget Festival</a>, St. Irénée, Quebec.</li>
      <li>Cello studies in Maryland with Barbara Brown and <a href="https://www.dcyop.org/" target="_blank" rel="noopener noreferrer">DC Youth Orchestra</a>.</li>
    </ul>

    <h3>Other Interests</h3>
    <ul>
      <li>When not occupied in the workshop, I enjoy gardening, cooking, skiing, and bicycling.</li>
    </ul>

    <h3>Colleagues &amp; Friends</h3>
    <ul>
      <li>David T. Van Zandt, maker in Seattle. <a href="https://www.vanzandtviolins.com" target="_blank" rel="noopener noreferrer">www.vanzandtviolins.com</a></li>
      <li>The Viola da Gamba Society of America. <a href="https://www.vdgsa.org" target="_blank" rel="noopener noreferrer">www.vdgsa.org</a></li>
      <li>Student cello repertoire recordings by Barbara Brown. <a href="http://apprenticemusic.com/index.html" target="_blank" rel="noopener noreferrer">www.apprenticemusic.com</a></li>
      <li>Early Music America. <a href="https://www.earlymusicamerica.org/" target="_blank" rel="noopener noreferrer">www.earlymusic.org</a></li>
      <li>Colin Skofield logo designed by <a href="http://www.alexfram.com/" target="_blank" rel="noopener noreferrer">Alex Fram</a></li>
    </ul>
  </section>
);

export default About;